import React, { useEffect, useRef } from 'react';

const GoogleAd = ({ slot, format = 'auto', responsive = true, className = '', style = {}, dataAdtest, onAdLoaded, clickUrl, ...rest }) => {
  const adRef = useRef(null);
  const envClient = process.env.REACT_APP_GOOGLE_ADS_CLIENT;
  const envSlot = process.env.REACT_APP_AD_SLOT_MAIN;
  const enableAdTestEnv = process.env.REACT_APP_ENABLE_ADTEST === 'true';
  const adClient = envClient || 'ca-pub-8619529008224723';
  const adSlot = slot || envSlot;
  const adTest = typeof dataAdtest === 'boolean' ? dataAdtest : enableAdTestEnv;
  const hasRun = useRef(false);
  const hasReportedLoad = useRef(false);

  useEffect(() => {
    hasReportedLoad.current = false;
  }, [adSlot]);

  useEffect(() => {
    hasRun.current = false;
  }, [adSlot]);

  useEffect(() => {
    if (!adRef.current || !onAdLoaded) return;

    const node = adRef.current;
    const observer = new MutationObserver(() => {
      const iframe = node.querySelector('iframe');
      if (iframe && !hasReportedLoad.current) {
        hasReportedLoad.current = true;
        onAdLoaded();
      }
    });

    observer.observe(node, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [onAdLoaded, adSlot]);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    window.adsbygoogle = window.adsbygoogle || [];
    let timer = null;

    const attemptPush = () => {
      try {
        if (!adRef.current) {
          timer = setTimeout(attemptPush, 200);
          return;
        }

        const height = adRef.current.clientHeight || adRef.current.offsetHeight || 0;
        if (height < 200) {
          timer = setTimeout(attemptPush, 300);
          return;
        }

        (window.adsbygoogle || []).push({});
      } catch (err) {
        console.error('adsbygoogle push error', err);
      }
    };

    // Start after a short delay to allow layout to settle (SPA timing)
    timer = setTimeout(attemptPush, 250);

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [adSlot]);

  const handleClick = () => {
    if (clickUrl) {
      window.open(clickUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <ins
      ref={adRef}
      className={`adsbygoogle ${className}`}
      style={{
        display: 'block',
        width: '100%',
        minHeight: '250px',
        backgroundColor: 'transparent',
        cursor: clickUrl ? 'pointer' : style.cursor,
        ...style
      }}
      data-ad-client={adClient}
      data-ad-slot={adSlot}
      data-ad-format={format}
      data-full-width-responsive={responsive ? 'true' : 'false'}
      {...(adTest ? { 'data-adtest': 'on' } : {})}
      onClick={clickUrl ? handleClick : undefined}
      {...rest}
    />
  );
};

export default GoogleAd;